import customerApi from 'api/customer';
import Loader from 'components/loader';
import Modal, {modalSizes} from 'components/layout/modal';
import Pagination from 'components/layout/pagination';
import PhoneNumber from 'components/phoneNumber';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import SearchField from 'components/searchField';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class SearchCustomerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      filter: '',
      customers: [],
      count: 0,
      total: 0,
      page: 1,
    };
  }

  componentWillMount() {
    let {filter, page} = this.state;

    this.fetchCustomers(filter, page);
  }

  componentWillUpdate(nextProps, nextState) {
    let {filter, page} = this.state;

    if(nextState.filter !== filter || nextState.page !== page) {
      this.fetchCustomers(nextState.filter, nextState.page);
    }
  }

  onPageChange = e => {
    let newPage = e !== undefined && e > 0 ? e : 1;

    this.setState({page: newPage});
  };

  getCustomerRows() {
    let {customerID} = this.props;
    let {customers} = this.state;
    let {formatMessage} = this.props.intl;
    let customerRows = customers.filter(x => (!x.AccountNo || x.CustomerContacts && x.CustomerContacts.length > 0) && x.cId != customerID).map((customer, index) => {

      if (customer.AccountNo) {
        let contact = customer.CustomerContacts[0] || {};

        customer.cId = customer.ID;
        customer.accountNo = customer.AccountNo;
        customer.name = contact.NameFirst + ' ' + contact.NameLast;
        customer.name = customer.name.trim();
        customer.organization = customer.Organization;
        customer.inactive = customer.Inactive;
        customer.address1 = customer.Address1;
        customer.email = contact.Email;
        customer.homePhone = contact.HomePhone;
        customer.fav = customer.Favourite;
        customer.flag = customer.Flag;
      }

      let displayName;

      if (customer && customer.name && typeof customer.name === 'string' && customer.name.trim().length === 0) {
        displayName =
          <td className='search-of'>
            <span style={{fontWeight: '600'}}>{customer.organization} {customer.inactive ? '(' + formatMessage({id: 'general.inactive'}) + ')' : ''}</span>
          </td>
        ;
      } else {
        displayName =
          <td className='search-of'>
            <span style={{fontWeight: '600'}}>{customer.name} {customer.inactive ? '(' + formatMessage({id: 'general.inactive'}) + ')' : ''}</span>
            <br/>
            {customer.organization}
          </td>
        ;
      }

      return (
        <tr key={index} className={customer.inactive ? 'inactive' : ''} onClick={() => this.compare(customer.cId)}>
          <td>
            {customer.accountNo}
          </td>
          {displayName}
          <td className='search-of'>
            {customer.address1}
          </td>
          <td className='search-of'>
            {customer.email}
          </td>
          <td className='search-of'>
            <PhoneNumber>{customer.homePhone}</PhoneNumber>
          </td>
        </tr>
      );
    });

    return customerRows;

  }

  compare = id => {
    let {customerID, onClose} = this.props;

    onClose();
    window.location.hash = `tools/accounts/merge-customer/${customerID}/${id}/true`;
  };

  fetchCustomers = (filter = '', page = 1) => {
    this.setState({loaded: false});
    customerApi.getCustomers(filter, page)
      .then(customers => {
        this.setState({
          loaded: true,
          customers: customers.rows,
          count: customers.count,
          total: customers.total,
          page: customers.page,
        });
      });
  };

  filterChange = e => {
    this.setState({filter: e});
  };

  render() {
    let {onClose} = this.props;
    let {customers, filter, loaded, page} = this.state;
    let customerRows = this.getCustomerRows();
    let {formatMessage} = this.props.intl;

    return <Modal className='search-customers-modal' size={modalSizes.large}  onClose={onClose} width={1024}>
      <div className="row">
        <h1><FormattedMessage id="general.merge.accounts" /></h1>
        <hr/>
      </div>
      <div className='row search-customers'>
        <div className='col-sm-2'>
          <h4><FormattedMessage id='customer.search.find' /></h4>
        </div>
        <div className='col-sm-10'>
          <SearchField placeholder={formatMessage({id: 'customer.search.placeholder'})} initialValue={filter} key='search-field'
                onSearch={this.filterChange} debounceDelay={500} />
        </div>
      </div>
      <Loader loaded={loaded}>
        <div className="row result-table">
          <table className='table table-striped table-hover table-biolab hoverClick'>
            <thead>
              <tr>
                <th style={{width: '10%'}}><FormattedMessage id="general.account" /></th>
                <th style={{width: '23%'}}><FormattedMessage id="general.customer" /></th>
                <th style={{width: '23%'}}><FormattedMessage id="general.address" /> </th>
                <th style={{width: '20%'}}><FormattedMessage id="general.email" /></th>
                <th style={{width: '15%'}}><FormattedMessage id="general.phone.number" /></th>
              </tr>
            </thead>
            <tbody>
              {customerRows.length !== 0  ?
                  customerRows :
                  <tr key='-1'>
                    <td colSpan='100%'><i><FormattedMessage id="general.error.nomatches" /></i></td>
                  </tr>
                }
            </tbody>
          </table>
          <hr/>
        </div>
      </Loader>
      <div className="row pagination-container">
        {customers.length !== 0 ?
          <Pagination
                onPageChange={this.onPageChange}
                page={this.state.page}
                count={this.state.count}
                total={this.state.total} /> :
            null}
      </div>
    </Modal>;
  }
}

SearchCustomerModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  customerID: PropTypes.number.isRequired,
};

export default injectIntl(SearchCustomerModal);
